import * as React from "react"
import { useTranslation } from "react-i18next"

export const ErrorComponent: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div
            className="flex flex-col items-center justify-center mt-6">
            <img
                src="assets/circle-exclamation.png"
                alt="Error Icon"
                className="h-12 w-auto object-contain mb-2"
            />
            <div className="flex flex-col gap-2 text-center mb-6">
                <h1 className="leading-[24px] text-[20px]">
                    {t('error.noAccess')}
                </h1>
                <p className="leading-[20px] text-[14px]">
                    {t('error.noAccessDescription')}
                </p>
            </div>
            <a className="underline cursor-pointer leading-[24px] text-[16px]" href={`mailto:${t('support.email')}`} target="_blank" rel="noopener noreferrer">
                {t('support.email')}
            </a>
        </div>
    )
}